module.exports = __webpack_public_path__ + "img/78.9dc8a7ac.png";